import { gql } from '@apollo/client'

export const CREATE_PRODUCT_FLAVOR = gql`
  mutation CreateFlavor($flavor: String!) {
    createProductFlavor(flavor: $flavor) {
      productFlavor {
        id
        flavor
        displayFlavor
      }
    }
  }
`
